// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Y1-z","dimensionLabel":"Z1-z","styleChooserControlWrapper":"_1-z","styleChooserControl":"a2-z","disabled":"b2-z","giftCard":"c2-z","styleChooserText":"d2-z"};